module.exports = __webpack_public_path__ + "img/cy2.7415a4e6.png";